import CloudwatchMetricConfigurer, { queryFinder } from './metricConfigurer';

import { metricStoreConfigStore } from '@spinnaker/kayenta';


metricStoreConfigStore.register({
  name: 'cloudwatch',
  metricConfigurer: CloudwatchMetricConfigurer,
  queryFinder,
});
